export const adaptiveTextGroups = {
  gridColumnHeaders: "grid-column-headers",
  gridRowHeaders: "grid-row-headers",
  rankSlots: "rank-slots",
} as const;
